import { FC } from 'react';
import QuizService from '../../../services/quiz.service';
import ScrapeUrlDialog from '../../common/ScrapeUrlDialog';

interface QuizScrapeUrlDialogProps {
  onClose: () => void;
  quizId: string;
}

const QuizScrapeUrlDialog: FC<QuizScrapeUrlDialogProps> = ({
  onClose,
  quizId,
}) => {
  return (
    <ScrapeUrlDialog
      entityId={quizId}
      onClose={onClose}
      onScrapeUrl={QuizService.scrapeUrl}
    />
  );
};

export default QuizScrapeUrlDialog;
